import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import {
  doUserLogin,
  doForgetPassword,
  doChangePassword,
  doFetchDashboard,
  doFetchTransactions,
  doFetchNotifications,
  doFetchLogs,
  doVerifyOTP,
} from "../../service/auth";
import errorMessage from "../../utils/error.json";

function* userLoginTask(action) {
  try {
    yield put({ type: OP.LOGIN_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doUserLogin,
      payload.username,
      payload.password,
    );

    if (res.status == 200) {
      yield put({
        type: OP.LOGIN_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.response.code]
        : errorMessage[1000];
      yield put({
        type: OP.LOGIN_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.LOGIN_FAILURE,
      payload: errMsg,
    });
  }
}

function* verifyOtpTask(action) {
  try {
    yield put({ type: OP.OTP_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doVerifyOTP,
      payload.username,
      payload.OTP,
    );

    if (res.status == 200) {
      yield put({
        type: OP.OTP_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.response.code]
        : errorMessage[1000];
      yield put({
        type: OP.OTP_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.OTP_FAILURE,
      payload: errMsg,
    });
  }
}

function* forgetPasswordTask(action) {
  try {
    yield put({ type: OP.FORGET_PASSWORD_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doForgetPassword, payload.data);

    if (res.status == 200) {
      yield put({
        type: OP.FORGET_PASSWORD_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.FORGET_PASSWORD_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.FORGET_PASSWORD_FAILURE,
      payload: errMsg,
    });
  }
}

function* changePasswordTask(action) {
  try {
    yield put({ type: OP.CHANGE_PASSWORD_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doChangePassword,
      payload.token,
      payload.data,
    );

    if (res.status == 200) {
      yield put({
        type: OP.CHANGE_PASSWORD_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.CHANGE_PASSWORD_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.CHANGE_PASSWORD_FAILURE,
      payload: errMsg,
    });
  }
}

function* fetchDashboardTask(action) {
  try {
    yield put({ type: OP.DASHBOARD_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchDashboard, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.DASHBOARD_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.DASHBOARD_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.DASHBOARD_FAILURE,
      payload: errMsg,
    });
  }
}

// -------- Transactions
function* transactionsTask(action) {
  try {
    yield put({ type: OP.TRANSACTIONS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doFetchTransactions,
      payload.token,
    );

    if (res.status == 200) {
      yield put({
        type: OP.TRANSACTIONS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.TRANSACTIONS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.TRANSACTIONS_FAILURE,
      payload: errMsg,
    });
  }
}

// -------- Notifications
function* notificationsTask(action) {
  try {
    yield put({ type: OP.NOTIFICATIONS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doFetchNotifications,
      payload.token,
    );

    if (res.status == 200) {
      yield put({
        type: OP.NOTIFICATIONS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.NOTIFICATIONS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.NOTIFICATIONS_FAILURE,
      payload: errMsg,
    });
  }
}

// -------- Logs
function* logsTask(action) {
  try {
    yield put({ type: OP.LOGS_LOADING });

    const { payload } = action;

    const { res, decoded_data } = yield call(doFetchLogs, payload.token);

    if (res.status == 200) {
      yield put({
        type: OP.LOGS_SUCCESS,
        payload: decoded_data.data, //save all data to payload
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];
      yield put({
        type: OP.LOGS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.LOGS_FAILURE,
      payload: errMsg,
    });
  }
}

function* authSaga() {
  yield takeLatest(OP.LOGIN_REQUEST, userLoginTask);
  yield takeLatest(OP.OTP_REQUEST, verifyOtpTask);
  yield takeLatest(OP.FORGET_PASSWORD_REQUEST, forgetPasswordTask);
  yield takeLatest(OP.CHANGE_PASSWORD_REQUEST, changePasswordTask);
  yield takeLatest(OP.DASHBOARD_REQUEST, fetchDashboardTask);
  yield takeLatest(OP.TRANSACTIONS_REQUEST, transactionsTask);
  yield takeLatest(OP.NOTIFICATIONS_REQUEST, notificationsTask);
  yield takeLatest(OP.LOGS_REQUEST, logsTask);
}

export default authSaga;
